// GUARDS
export const editorIsInactive = ({ isInactive }) => isInactive;

export const editorNotDirty = ({ isDirty }) => !isDirty;

// Guard to check if machine's state will allow for publishing the post
export const publishingAllowed = (context) => {
    // Add additional checks here
    // i.e. text length

    return !context.isInactive && context.postText.length > 0;
};
